import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Startseite from "../components/startseite/startseite.component"

const Index = ({ location }) => (
  <Layout location={location}>
    <Seo
      title={"Pflegedienst Nürnberg – herzlich, kompetent, verbindlich"}
      description={
        "Sie suchen einen Pflegedienst für Nürnberg und Umgebung? Wir unterstützen Sie und Ihre Angehörigen mit Herzlichkeit im Alltag."
      }
    />
    <Startseite />
  </Layout>
)

export default Index
